import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { 
  Box, Typography, Avatar, FormControl, InputLabel, MenuItem, Select 
} from "@mui/material";
import { Link } from "react-router-dom";
import gsap from "gsap";
import MDBox from "../components/MDBox";
import MDInput from "../components/MDInput";

function AllotteeDashboard({ currentUser, properties }) {
  // Create refs for animation
  const headingRef = useRef(null);
  const inputRefs = useRef([]);
  const buttonRef = useRef(null);

  // GSAP Animation
  useEffect(() => {
    gsap.from(headingRef.current, {
      duration: 1,
      x: -100,
      opacity: 0,
      ease: "power3.out",
    });

    gsap.from(inputRefs.current, {
      duration: 1,
      x: -50,
      opacity: 0,
      stagger: 0.2,
      ease: "power3.out",
      delay: 0.5,
    });

    gsap.from(buttonRef.current, {
      duration: 1,
      y: 50,
      opacity: 0,
      ease: "bounce.out",
      delay: 1.5,
    });
  }, []);

  return (
    <MDBox py={3} style={{ padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }} ref={headingRef}>
        <Typography variant="h4" style={{ fontWeight: '600', color: '#344767' }}>
          Your Profile Details
        </Typography>
      </div>

      <Box display="flex" justifyContent="center" mb={4}>
        <Avatar
          src={currentUser?.img || "default-profile.png"}
          alt="Profile"
          sx={{ width: 150, height: 150, border: "4px solid #45a049", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}
        />
      </Box>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '600px', margin: '0 auto' }}>
        {["owners_name", "occupiers_name", "email", "phone", "block_number", "flat_number"].map((field, index) => (
          <MDBox key={field} mb={3} style={{ width: '100%' }} ref={(el) => (inputRefs.current[index] = el)}>
            <MDInput
              type={field === "email" ? "email" : "text"}
              label={field.replace("_", " ").replace("owners", "Owner's").replace("occupiers", "Occupier's").replace("block", "Block").replace("flat", "Flat").replace("phone", "Phone Number").replace("email", "Email Address")}
              variant="outlined"
              fullWidth
              name={field}
              value={currentUser?.[field] || ""}
              disabled
              style={{ backgroundColor: '#fff', borderRadius: '8px' }}
            />
          </MDBox>
        ))}

        <MDBox mb={3} ref={(el) => (inputRefs.current[4] = el)}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="location-label" style={{ color: '#344767' }}>Location</InputLabel>
            <Select
              labelId="location-label"
              id="location-select"
              name="location"
              value={currentUser?.location || ""}
              disabled
              style={{ backgroundColor: '#fff', borderRadius: '8px' }}
            >
              <MenuItem value={currentUser?.location}>
                {currentUser?.location ? currentUser.location.charAt(0).toUpperCase() + currentUser.location.slice(1) : "None"}
              </MenuItem>
            </Select>
          </FormControl>
        </MDBox>
      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem' }} ref={buttonRef}>
        <Link
          to={`/profile`}
          style={{
            textDecoration: 'none',
            backgroundColor: '#4CAF50',
            color: '#fff',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            fontWeight: '600',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#45a049')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#4CAF50')}
        >
          Edit Profile
        </Link>
      </div>
    </MDBox>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.alloteeReducer?.currentUser || {},
  properties: state.alloteeReducer?.properties || [],
});

export default connect(mapStateToProps, null)(AllotteeDashboard);